import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { Icon, IconName } from '../../atoms/icons';

export interface Props {
  className?: string;
  icon?: IconName;
  baseColor?: string;
}

export class SearchAlignedIcon extends React.Component<Props> {
  public render() {
    const { className, icon, baseColor } = this.props;

    return <Icon className={className} icon={icon} baseColor={baseColor} />;
  }
}

export default styled(SearchAlignedIcon)`
  width: 42px !important;
  margin-right: 6px;
`;
